import { requestService as api } from "./Request.service"  
const API_URL = { 
  API_MANAGE: `/purchaseorder/manage.php`, 
  API_SEARCH: `/purchaseorder/search.php`, 

  API_GETCODE: `/purchaseorder/get-doc-code.php`, 
  API_PREPARE: `/purchaseorder/prepare-po.php`, 
};
  
const QuotationService = () => { 
  
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);

  const code = () => api.get(`${API_URL.API_GETCODE}`);
  const prepare = (code) => api.get(`${API_URL.API_PREPARE}?code=${code}`);

  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});
  

  return {
    create,
    update,
    deleted,
    get, 

    code,
    prepare,
    search,
  };
};

export default QuotationService;